<template>
  <div class="d-flex flex-column">
    <div class="row justify-content-between">
      <div class="col-12 col-sm-4 d-flex">
        <card :title="$t('sections.tamLandingPage.numbers.title')" divider>
          <div class="row">
            <div class="d-flex flex-column col-auto">
              <HorizontalDetailTitle
                :label="$t('sections.tamLandingPage.numbers.totalTariffs')"
              />
            </div>
            <div class="d-flex flex-column col-auto flex-fill pl-4">
              <HorizontalDetailInput :field="tariffsCount" :edit="false" />
            </div>
          </div>
        </card>
      </div>
      <div class="col-12 col-sm-8">
        <BarChart
          v-if="!getLoading"
          :labels="tariffsByPartyIdLabels"
          :datasets="tariffsByPartyIdDatasets"
          :title="$t('sections.tamLandingPage.graph.dataLabel')"
          class="mb-3"
        />
      </div>
    </div>
    <span class="section-title" v-if="alarmsPermissions.read">
      {{ $t("sections.tamLandingPage.table.title") }}
    </span>
    <PaginationWrapper
      :page="page"
      :totalCount="totalCount"
      @onPageChange="handlePageChange"
      export
      @exportTable="exportList"
      v-if="alarmsPermissions.read"
    >
      <!-- <div slot="table">
        <base-table :data="getAlarms">
          <el-table-column
            prop="id"
            :label="$t('sections.tamLandingPage.table.id')"
          />
        </base-table>
      </div> -->
      <AlarmsSearchOptions @onSearch="handleSearch" slot="search-options" :modules=false />
      <AlarmsTable slot="table" />
    </PaginationWrapper>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import HorizontalDetailTitle from '@/components/ui/HorizontalDetailTitle.vue';
import HorizontalDetailInput from '@/components/ui/HorizontalDetailInput.vue';
import BarChart from '@/components/ui/charts/BarChart.vue';
import PaginationWrapper from '@/components/sections/common/PaginationWrapper.vue';
import AlarmsTable from '@/components/sections/alarms/AlarmsTable';
import AlarmsSearchOptions from '@/components/sections/alarms/AlarmsSearchOptions';

export default {
  name: 'TariffsManagerLandingPage',
  components: {
    HorizontalDetailTitle,
    HorizontalDetailInput,
    BarChart,
    PaginationWrapper,
    AlarmsTable,
    AlarmsSearchOptions,
  },
  data() {
    return {
      tariffsCount: 0,
      tariffsByPartyIdLabels: [],
      tariffsByPartyIdValues: [],
      page: 1,
      totalCount: 0,
      query: {},
    };
  },
  computed: {
    ...mapGetters(['getLoading', 'getAlarms', 'getPagePermissions']),
    alarmsPermissions() {
      return this.getPagePermissions('Alarms Manager - Alarms');
    },
    tariffsByPartyIdDatasets() {
      return [
        {
          label: this.$t('sections.tamLandingPage.graph.dataLabel'),
          borderColor: '#1a84cf',
          backgroundColor: 'rgba(26, 132, 207, 0.5)',
          data: this.tariffsByPartyIdValues,
        },
      ];
    },
  },
  mounted() {
    this.fetchData();
    this.fetchAlarmsData();
  },
  methods: {
    async handleSearch(query) {
      this.page = 1;
      this.query = query;
      await this.fetchAlarmsData();
    },
    async fetchAlarmsData() {
      this.$store.dispatch('storeLoading', true);
      this.totalCount = await this.$store.dispatch('storeAlarms', {
        query: {
          ...this.query,
          module: 'Tariffs Manager',
        },
        page: this.page,
      });
      this.$store.dispatch('storeLoading', false);
    },
    async fetchData() {
      this.$store.dispatch('storeLoading', true);
      try {
        const analytics = await this.$store.dispatch('getTariffsAnalytics');

        this.tariffsCount = analytics.tariffsCount;

        this.tariffsByPartyIdLabels = analytics.countByPartyId.labels;
        this.tariffsByPartyIdValues = analytics.countByPartyId.values;
      } catch (e) {
        console.log("Couldn't get tariffs analytics.");
      }

      this.$store.dispatch('storeLoading', false);
    },
    async handlePageChange(page) {
      this.page = page;
      await this.fetchData();
    },
    async exportList() {
      await this.$store.dispatch('storeLoading', true);

      try {
        const file = await this.$store.dispatch('exportList', {
          query: this.query,
          type: 'alarms',
        });

        if (file.data === '') {
          this.$message.error(
            this.$t('components.alerts.exportFileError', { type: 'alarms' }),
          );
        } else {
          const fileURL = window.URL.createObjectURL(new Blob([file.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute(
            'download',
            `alarms-${new Date()
              .toISOString()
              .slice(0, 10)
              .replaceAll('-', '')}.csv`,
          );
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$message.success(
            this.$t('components.alerts.exportSuccess', { type: 'alarms' }),
          );
        }
      } catch (e) {
        this.$message.error(
          this.$t('components.alerts.exportError', { type: 'alarms' }),
        );
        console.log(e);
      }

      await this.$store.dispatch('storeLoading', false);
    },
  },
};
</script>
